// extracted by mini-css-extract-plugin
export default {"header":"ConsultingPackage_header__R3Fl2","container":"ConsultingPackage_container__k0pOY","list":"ConsultingPackage_list__QGE7F","img":"ConsultingPackage_img__87AqM"};